import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DataService } from './data.service';
import { Util } from '../util';
import { Observable } from 'rxjs/Observable';


@Injectable()
export class DocumentoAssinadoService extends DataService {

  private url = this.urlApi + 'v1/documentoAssinado/';

  constructor(private http: HttpClient) {
    super();
  }

  getByIdCadidato(id: string) {
    return this.http.get<any>(this.url + 'getByIdCandidato/' + id)
    .catch(this.handleError);
  }

  removerDocumentoAssinado(id: string) {
    return this.http.delete(this.url + 'removerDocumento/' + id)
    .catch(this.handleError);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/shared/services/documento-assinado.service.ts